<template>
  <vetster-collapse is-open>
    <div
      slot="header"
      class="text-xl 2xl:text-2xl font-title font-semibold text-ocean-900"
    >
      {{ $t('blogpost.meet-our-vets') }}
    </div>
    <div
      slot="content"
      class="mt-2"
    >
      <div class="vetster-prose text-neutral-900">
        {{ $t('blogpost.get-better-vet-care') }}
      </div>
      <vetster-button
        variant="bubblegum"
        :href="guidedSearchUrl"
        size="fixed"
        class="mt-4"
      >
        <fa
          :icon="['fas', 'video']"
          class="text-xl"
        />
        <span>{{ $t('membership-subscriptions.talk-to-a-vet') }}</span>
      </vetster-button>
    </div>
  </vetster-collapse>
</template>

<script>
import VetsterCollapse from '@/components/VetsterCollapse';
import LocalizesRoutes from '@/mixins/LocalizesRoutes';

export default {
  name: 'VetsterMeetOurVet',

  components: { VetsterCollapse },

  mixins: [LocalizesRoutes],
};
</script>
